module.exports = __webpack_public_path__ + "static/media/clouds3.6c400694.png";